import APIService from '@/services/APIService.js';

export default {
  getLogs() {
    return APIService.apiCall().get('/logs-acessos-usuarios/get-logs');
  }
};
